export default __webpack_public_path__ + "static/media/logo-integrity.f8db149d.svg";